module.exports = __webpack_public_path__ + "img/genres.6b5b7fe7.webp";